import { render, staticRenderFns } from "./BriqInputMultiple.vue?vue&type=template&id=9449be7e&scoped=true&lang=pug&"
import script from "./BriqInputMultiple.vue?vue&type=script&lang=js&"
export * from "./BriqInputMultiple.vue?vue&type=script&lang=js&"
import style0 from "./BriqInputMultiple.vue?vue&type=style&index=0&id=9449be7e&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9449be7e",
  null
  
)

export default component.exports